import * as React from 'react';
import * as s from './Logo.scss';
import { getResizedImageUrl } from '@wix/media-manager';
//FIXME use this is failing in case of logo = "//static.wixstatic.com/media/", need to have a better fix
var logoFitUrl = function (logo, width) {
    var logoFilename = logo.match(/(?:[^\/]+)$/)[0];
    var logoResizedUrl = getResizedImageUrl(logoFilename, width, 100);
    return logoResizedUrl.replace('/fill/', '/fit/');
};
export var Logo = function (_a) {
    var _b = _a.onImageReady, onImageReady = _b === void 0 ? function () { } : _b, logo = _a.logo;
    var hasLogo = function () { return logo && logo.match(/(?:[^\/]+)$/); };
    var handleLogoNotExist = function () {
        onImageReady();
        return (React.createElement("div", { style: { height: '10px' } }));
    };
    return hasLogo() ? (React.createElement("div", { className: s.logo, "data-hook": "business-logo" },
        React.createElement("img", { decoding: "sync", src: logoFitUrl(logo, 311), onError: function (_a) {
                var image = _a.target;
                image.parentElement.style.display = 'none';
                onImageReady();
            }, onLoad: onImageReady }))) : (handleLogoNotExist());
};
//# sourceMappingURL=Logo.js.map